// extracted by mini-css-extract-plugin
module.exports = {"cls1":"footer-FooterWrapper-module--cls1--3G30O"};